module.exports = __webpack_public_path__ + "img/level-1.d208f210.png";